import { render } from "./WidgetConfigModal.vue?vue&type=template&id=6a9cfc3d&scoped=true"
import script from "./WidgetConfigModal.vue?vue&type=script&lang=js"
export * from "./WidgetConfigModal.vue?vue&type=script&lang=js"

import "./WidgetConfigModal.vue?vue&type=style&index=0&id=6a9cfc3d&scoped=true&lang=css"

import exportComponent from "/usr/app/workspace-stack/frontend-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a9cfc3d"]])

export default __exports__